import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import parse, { domToReact } from 'html-react-parser';
import { useLocation } from '@reach/router';

import useLocale from 'hooks/useLocale';

import WpImage from 'components/Elements/WPImage';
import Socials from 'components/Elements/Socials/Shared';
import * as styles from './styles.module.scss';

const options = {
  replace: (node) => {
    if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(node.name)) {
      return (
        <h2 className={classnames('cr-h3', styles.article_title)}>
          {domToReact(node.children, options)}
        </h2>
      );
    }

    if (node.name === 'p') {
      const image = getImage(node);

      if (image != null) {
        return (
          <div>
            <WpImage
              src={image.attribs.src}
              alt={image.attribs.alt}
              width={image.attribs.width}
            />
          </div>
        );
      }
    }

    if (node.name === 'ul') {
      return (
        <ul className={classnames('cr-dotted-list ', styles.article_list)}>
          {domToReact(node.children, options)}
        </ul>
      );
    }

    if (node.name === 'ol') {
      return (
        <ol className={classnames('cr-num-list ', styles.article_list)}>
          {domToReact(node.children, options)}
        </ol>
      );
    }

    return node;
  },
};

const getImage = (node) => {
  if (node.name === 'img') {
    return node;
  } else if (node.children != null) {
    for (let index = 0; index < node.children.length; index++) {
      const image = getImage(node.children[index]);

      if (image != null) return image;
    }
  }
};

const Article = ({
  data: {
    title,
    blog: { textContent },
    tags: { nodes: tags },
  },
}) => {
  const locale = useLocale();
  const location = useLocation();

  const content = parse(textContent || '', options);

  return (
    <div>
      <div className={styles.article_main}>
        <div className={classnames('cr-reg', styles.article_text)}>
          {content}
        </div>

        <div className={styles.article_categories}>
          <ul className={styles.article_categories_list}>
            {tags.map((tag) => (
              <li key={tag.slug}>
                <Link
                  to={tag.slug}
                  className={classnames('cr-reg cr-main cr-link')}
                >
                  # {tag.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div>
        <div className={styles.article_socials}>
          <p className={classnames('cr-h5', styles.article_socials_title)}>
            {locale.code === 'EN'
              ? 'Share this article'
              : 'Teilen Sie diesen Beitrag'}
          </p>

          <div>
            <Socials text={title} url={location.href} mod={'black'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article;
